import { render, staticRenderFns } from "./OrderItemDesignEditDialog.vue?vue&type=template&id=73d116a8&scoped=true"
import script from "./OrderItemDesignEditDialog.vue?vue&type=script&lang=js"
export * from "./OrderItemDesignEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d116a8",
  null
  
)

export default component.exports